export default __webpack_public_path__ + "static/media/logo.9a94a143.png";